module.exports = __webpack_public_path__ + "img/compensation1.f1751c2a.png";